import { createContext, ReactNode } from 'react'

export type ModalActionsElement = ReactNode

type ModalActionContextValue = { actions: ModalActionsElement; setModalActions: (actions: ModalActionsElement) => void }

const error = () => {
  throw Error('ModalActionProvider not found')
}

export const ModalActionContext = createContext<ModalActionContextValue>({
  actions: undefined,
  setModalActions: error,
})
